// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"cde45e71","113":"92f5aa9f","121":"3c3ec3af","142":"1aff2363","358":"3baea4b9","438":"b6a64ab9","538":"48842a60","648":"74adbdc6"}[chunkId] + ".chunk.js";
};